export class AppContext {
	_menu

	/**
	 * Only one context should be active at a time
	 * open == true means it is visible and can be clicked
	 * If the anchor (<a>) of the menu item (in Menu.js) has the attribute alwaysVisible 
	 * it is still visible but disabled when open == false
	 */
	activityTree = {
		aboutUs: {
			active: true,
			open: true
		},
		counter: {
			active: false,
			open: false
		},
		login: {
			active: false,
			open: true
		},
		logout: {
			active: false,
			open: false,
			keycloakAccount: {
				active: false,
				open: false
			},
			userInfo: {
				active: false,
				open: false
			}
		}
	}

	/**
	 * Lookup for the contect in the tree above
	 */
	activities = {
		aboutUs: this.activityTree.aboutUs,
		counter: this.activityTree.counter,
		login: this.activityTree.login,
		logout: this.activityTree.logout,
		keycloakAccount: this.activityTree.logout.keycloakAccount,
		userInfo: this.activityTree.logout.userInfo
	}

	constructor() {
		window.addEventListener('popstate', ev => {
			if (ev.state) {
				this._setActive(ev.state.activity)
			}
		})
	}

	restore = () => {
		const initContextMatcher = window.location.pathname.match(/(?:\/fairshop)?\/(.*)/)
		if (initContextMatcher.length > 1) {
			const activityName = initContextMatcher[1] || 'counter'
			console.log('Init context:', activityName)
			const activity = this.activities[activityName]
			if (activity && activity.open === true) {
				this.setActive(activityName)
			}
			else {
				this.setActive('aboutUs')
			}
		}
		else {
			//this._setActive('stores')
		}
	}

	setMenu = menu => this._menu = menu

	setComponents = (activity, components) => this.activities[activity].components = components

	/**
	 * Called by menu to see if activity is currently active
	 * 
	 * @param {*} activity 
	 * @returns 
	 */
	isActive = activity => this.activities[activity].active

	/**
	 * Called by menu to update context and set component visible.
	 * Only one activity can be active.
	 * Adds the activity to history stack.
	 * 
	 * @param {*} activity 
	 */
	setActive = activity => {
		this._setActive(activity)
		window.history.pushState({ activity: activity }, '', activity === 'counter' ? '/' : activity)
	}

	_setActive = activity => {
		// Hide all
		Object.values(this.activities).forEach(a => {
			a.active = false
			if (a.components) {
				a.components.forEach(c => c.setVisible(false))
			}
		})
		const newActivity = this.activities[activity]
		if (newActivity.components) {
			newActivity.components.forEach(c => {
				// Show components of activity
				c.setVisible(true)
			})
		}
		newActivity.active = true
		this._menu.setActive(activity)
		// Follow url
		console.log('Navigated to: ', activity)
	}

	/**
	 * Called by menu to see if menu entry can be clicked
	 * @param {*} activity 
	 * @returns 
	 */
	isOpen = activity => this.activities[activity].open

	setOpen = (activity, open) => {
		this.activities[activity].open = open
		this._menu.setOpen(activity, open)
		// TODO react when the activity is active
	}
}